module.exports = __webpack_public_path__ + "img/组 126@2x(4).d2e792f2.png";